import { createFileRoute } from '@tanstack/react-router';
import { SprintBoardPage } from '#web/features/sprint-board/SprintBoardPage';
import { sprintBoardSearchWithPatch, validateSprintBoardSearch } from '#web/features/sprint-board/sprint-board-search';

/** Home: Face Up's sprint board, with its filters in the URL. */
export const Route = createFileRoute('/_app/')({
  component: HomePage,
  validateSearch: validateSprintBoardSearch,
});

function HomePage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SprintBoardPage
      search={search}
      onSearchPatch={(patch) =>
        void navigate({ replace: true, search: (previous) => sprintBoardSearchWithPatch(previous, patch) })
      }
    />
  );
}
